import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Button, Box } from '@indeed/ifl-components';
import { style } from './Maintenance.jss';
const MaintenancePage = () => {
    const history = useHistory();
    useEffect(() => {
        if (!window.proctorGroups.univ_maintenance_tst) {
            history.push('/');
        }
    }, [history]);
    return (React.createElement(Box, { sx: style.main },
        React.createElement("div", null,
            React.createElement(Box, { sx: style.background }),
            React.createElement(Box, { as: "h1", sx: style.title }, "\u7533\u3057\u8A33\u3042\u308A\u307E\u305B\u3093\u304C\u3001\u73FE\u5728\u30E1\u30F3\u30C6\u30CA\u30F3\u30B9\u4E2D\u3067\u3059\u3002"),
            React.createElement(Box, { as: "p", sx: style.description, dangerouslySetInnerHTML: {
                    __html: window.initialData.maintenanceMsg ?? ''
                } }),
            React.createElement(Button, { full: true, variant: "primary", onClick: () => {
                    window.location.assign('/rirekisho/form');
                } }, "\u30DA\u30FC\u30B8\u306E\u518D\u8AAD\u307F\u8FBC\u307F"))));
};
export default MaintenancePage;
